import { MultiSelect } from "@mantine/core";
import React, { useState } from "react";
import { Alert, Col, Input, Label, Row, Spinner } from "reactstrap";
import { getAssignationManagementResidueFinalDestinationList } from "../../../../helpers/residue/backend_helper";
import { useEffect } from "react";
// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import ConversionSection from "../Forms/ConversionSection";
import { useDispatch } from "react-redux";
import { getUnitMeasurementList } from "../../../../slices/thunks";

const ResidueConversionTab = ({
    key,
    dataResidue,
    dataResidueConversionList,
    handleDataResidueConversionList
}) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);

    const [unitMeasurementList, setUnitMeasurementList] = useState([]);
    

    async function loadUnitMeasurements(){
        try {
            const response = await dispatch(getUnitMeasurementList()).unwrap();

            const unitMeasurements = response;
            setUnitMeasurementList(unitMeasurements.filter(unitMeasurement => unitMeasurement.code != 'KG'))
            setIsLoading(false);
        } catch (err){
            setIsLoading(false);
            console.error('Error:', err);
        }
    }

    useEffect(() => {
        loadUnitMeasurements();
    }, [])

    return (
        <React.Fragment>
            <div>
                <h5>Listado de conversiones</h5>
            </div>
            {isLoading ? (
                <Alert color='primary'>
                    <Spinner size='sm' className='me-2' />
                    Cargando datos, por favor espere...
                </Alert>
            ) : null}
            {(unitMeasurementList.map((unitMeasurement, index) => {
                return <ConversionSection
                    key={index}
                    dataResidue={dataResidue}
                    dataUnitMeasurement={unitMeasurement}
                    dataResidueConversionList={dataResidueConversionList}
                    handleDataResidueConversionList={handleDataResidueConversionList}
                />
            }))}
        </React.Fragment>
    )
}

export default ResidueConversionTab;